import { chunkArray } from "@/utils";
import slideDistance from "@/utils/slideDistance";
import classNames from "classnames";
export default function CardWrap({ style, itemList, useTransparentStyle = false }: any) {
  const chunkList = chunkArray(itemList, 3);
  const itemRef = useRef<HTMLDivElement>(null);
  const titleRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const valueRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const animateTitle = (refs: any) => {
    Object.values(refs).forEach((element: any) => {
      if (element) {
        slideDistance({
          speed: 0.01,
          end: element.parentElement?.parentElement?.clientWidth - element.clientWidth,
        })(element);
      }
    });
  };

  const animateValue = (refs: any) => {
    Object.values(refs).forEach((element: any) => {
      if (element) {
        slideDistance({
          speed: 0.01,
          end: element.parentElement?.clientWidth - element.clientWidth,
        })(element);
      }
    });
  };
  useEffect(() => {
    animateTitle(titleRefs.current);
    animateValue(valueRefs.current);
  }, []);
  return (
    <WeatherContent className={classNames(["p-16 rounded-10"])} style={style} useTransparentStyle={useTransparentStyle}>
      {chunkList.map((it1: any, idx1: number) => {
        return (
          <div
            key={idx1}
            className={
              "grid grid-cols-[repeat(3,calc(100%/3))] border-b-1 border-b-solid border-b-[var(--app-border-05)] last:border-b-none"
            }
          >
            {it1.map((it2: any, idx2: number) => {
              const refKey = `${idx1}_${idx2}`;
              return (
                <div
                  key={refKey}
                  className={
                    "h-100 relative text-center w-full overflow-hidden after:content-[''] after:block after:w-1 after:h-80% after:bg-[var(--app-bg-09)] after:absolute after:top-50% after:translate-[0,-50%] first:after:display-[none]"
                  }
                >
                  <div
                    className="w-[calc(100%-16px)] p-[5px_0] overflow-hidden flex flex-col gap-y-5 items-center text-12 absolute top-50% left-50% translate-[-50%] whitespace-nowrap"
                    ref={itemRef}
                  >
                    <div className="w-full">
                      <div className="w-full items-center">
                        <WeatherImage className="w-20" src={it2?.icon} />
                      </div>

                      <div
                        className={classNames(["inline-block whitespace-nowrap px-4 py-0", "font-[Roboto_Light]"])}
                        ref={el => (titleRefs.current[refKey] = el)}
                      >
                        {it2.title}
                      </div>
                    </div>

                    <div
                      className={classNames(["inline-block whitespace-nowrap px-4 py-0", "font-[Roboto_Light]"])}
                      ref={el => (valueRefs.current[refKey] = el)}
                    >
                      {it2.value}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </WeatherContent>
  );
}
